import axios from "axios";
import { toast } from "react-toastify";

import {
    GET_PROMOS,
    ADD_PROMO,
    DELETE_PROMO,
    GET_PROMO,
    UPDATE_PROMO,
} from "../types";

const basePath = process.env.REACT_APP_API_URL + "/api/promo";

export const getPromos = ({ storeName, mallName }) => async dispatch => {
    try {
        let queryString = "";
        if (storeName !== undefined) {
            queryString += "storeName=" + storeName.replace("&", "%26") + "&";
        }
        if (mallName !== undefined) {
            queryString += "mallName=" + mallName.replace("&", "%26") + "&";
        }

        const res = await axios.get(`${basePath}/viewAll?${queryString}`);

        dispatch({
            type: GET_PROMOS,
            payload: res.data
        });

        return res.data.promos;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getPaginatePromos = (query) => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`, {
            params: query
        });

        dispatch({
            type: GET_PROMOS,
            payload: res.data
        });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
}

export const addPromo = data => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("title", data.title);
        formData.append("description", data.description);
        formData.append("isMallPromo", data.isMallPromo);
        formData.append("isStorePromo", data.isStorePromo);
        formData.append("isDeal", data.isDeal);
        formData.append("isEvent", data.isEvent);
        formData.append("dateFrom", data.dateFrom);
        formData.append("dateTill", data.dateTill);
        formData.append("offerOptionUsed", data.offerOptionId);

        const categoryIds = data.categoryIds;
        if (categoryIds.length) {
            categoryIds.forEach(categoryId => {
                formData.append("categoryIds[]", categoryId);
            });
        }

        if (data.source !== "") {
            formData.append("source", data.source);
        }

        const images = data.images;
        if (images.length) {
            images.forEach(image => {
                formData.append("images", image);
            });
        }

        const res = await axios.post(`${basePath}/add`, formData, config);

        dispatch({
            type: ADD_PROMO,
            payload: res.data
        });

        toast.success("Promotion Created.");

        return true;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const updatePromo = (data, id) => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("title", data.title);
        formData.append("description", data.description);
        formData.append("isMallPromo", data.isMallPromo);
        formData.append("isStorePromo", data.isStorePromo);
        formData.append("isDeal", data.isDeal);
        formData.append("isEvent", data.isEvent);
        formData.append("dateFrom", data.dateFrom);
        formData.append("dateTill", data.dateTill);
        formData.append("offerOptionUsed", data.offerOptionId);

        const categoryIds = data.categoryIds;
        if (categoryIds.length) {
            categoryIds.forEach(categoryId => {
                formData.append("categoryIds[]", categoryId);
            });
        }

        if (data.source !== "") {
            formData.append("source", data.source);
        }

        const images = data.images;
        if (images.length) {
            images.forEach(image => {
                formData.append("images[]", image);
            });
        }

        const files = data.files;
        if (files !== undefined && files.length) {
            files.forEach(file => {
                formData.append("files", file);
            });
        }

        const res = await axios.put(
            `${basePath}/update/${id}`,
            formData,
            config
        );

        dispatch({ type: UPDATE_PROMO, payload: res.data });

        toast.success("Promotion Updated.");

        return true;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getPromo = id => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/view/${id}`);

        dispatch({ type: GET_PROMO });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const deletePromo = id => async dispatch => {
    try {
        await axios.delete(`${basePath}/delete/${id}`);

        dispatch({
            type: DELETE_PROMO,
            payload: id
        });

        toast.success("Promo Deleted.");
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};
